import { jsPDF } from 'jspdf';

import { parseRGB } from './utils';

type SetColorProps = {
  pdf: jsPDF;
  color: string;
};

export const setFontColor = ({ pdf, color }: SetColorProps) => {
  if (!color) return;
  const hexColors = parseRGB(color);
  if (hexColors) {
    pdf.setTextColor(hexColors[0], hexColors[1], hexColors[2]);
    pdf.setDrawColor(hexColors[0], hexColors[1], hexColors[2]);
  }
};

type SetPdfTextStylingProps = {
  pdf: jsPDF;
  color: string;
  bold: boolean;
  italic: boolean;
};

const getFontStyleName = (bold: boolean, italic: boolean) => {
  if (bold && italic) return 'BoldItalic';
  if (bold) return 'Bold';
  if (italic) return 'Italic';
  return 'Normal';
};

export const setPdfTextStyling = ({
  pdf,
  color,
  bold = false,
  italic = false,
}: SetPdfTextStylingProps) => {
  setFontColor({ pdf, color });
  const currentFont = pdf.getFont().fontName;
  const fontStyleName = getFontStyleName(bold, italic);
  pdf.setFont(currentFont, fontStyleName);
};

type RenderUnderlineProps = {
  pdf: jsPDF;
  x: number;
  y: number;
  width: number;
};

export const renderUnderLine = ({ pdf, x, y, width }: RenderUnderlineProps) => {
  const fontSize = pdf.getFontSize();
  const underscoreLineOffset = fontSize / 12;
  pdf.setLineWidth(fontSize / 12);
  pdf.line(x, y + underscoreLineOffset, x + width, y + underscoreLineOffset);
};

type RenderLinkProps = {
  pdf: jsPDF;
  x: number;
  y: number;
  width: number;
  height: number;
  url: string;
};

export const renderLink = ({ pdf, x, y, width, height, url }: RenderLinkProps) => {
  pdf.link(x, y, width, height, {
    url,
  });
};
